import { render, staticRenderFns } from "./SectionTextActions.vue?vue&type=template&id=fc7db628&scoped=true&"
import script from "./SectionTextActions.vue?vue&type=script&lang=ts&"
export * from "./SectionTextActions.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTextActions.vue?vue&type=style&index=0&id=fc7db628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7db628",
  null
  
)

export default component.exports